import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m20.62 6.49-2.5 2.5L15 5.88l2.51-2.5A5.5 5.5 0 0 0 10.6 11l-6.8 6.8a1.7 1.7 0 0 0 2.4 2.4l6.8-6.8a5.5 5.5 0 0 0 7.62-6.91"
    }, null, -1)
  ])))
}
export default { render: render }